/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Col_FilesInputs */

const en_pc_alt_col_files = /** @type {(inputs: Pc_Alt_Col_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where files are processed`)
};

const zh_pc_alt_col_files = /** @type {(inputs: Pc_Alt_Col_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件在哪里处理`)
};

/**
* | output |
* | --- |
* | "Where files are processed" |
*
* @param {Pc_Alt_Col_FilesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_col_files = /** @type {((inputs?: Pc_Alt_Col_FilesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Col_FilesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_col_files(inputs)
	return zh_pc_alt_col_files(inputs)
});
export { pc_alt_col_files as "pc.alt.col.files" }